export default __webpack_public_path__ + "static/media/screen6.b22d5f2b.png";